<template>
  <div class="h-auto">
    <div v-if="isLoading" class="w-100 text-center py-5">
      <loader />
    </div>
    <template v-else>
      <div class="px-4 py-5" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <div class="w-100 p-4 bg-green" style="height: 300px">
          <!-- HEADER -->
          <div class="w-100 position-relative mb-4 text-center pt-3 pb-4">
            <p class="mb-0 body-1-4 text-white">{{ transactionDetail.status === 'COMPLETE' ? 'Delivery History' : 'Ongoing Order' }}</p>
          </div>
  
          <!-- DRIVER -->
          <div 
            class="radius-1 p-3 bg-white d-flex align-items-center mb-4"
            :class="{'cursor-pointer': showWaChat}"
            @click="goToWaChat()">
            <template v-if="delivery.driver_name">
              <div class="w-100 d-flex align-items-center">
                <div
                  v-if="delivery.driver_photo_url"
                  class="border-2-green rounded-circle overflow-hidden"
                  style="height: 50px; width: 50px">
                  <img :src="delivery.driver_photo_url" class="img-fit" />
                </div>
                <div class="pl-3">
                  <p class="mb-0 body-2-4" v-if="delivery.driver_name">
                    {{ delivery.driver_name }}
                  </p>
                  <p
                    class="mb-0 body-3"
                    v-if="delivery.driver_plate_number">
                    Driver - {{ delivery.driver_plate_number }}
                  </p>
                </div>
              </div>
              <div
                v-if="$isNotEmptyV2(delivery.driver_phone)"
                class="flex-shrink-0 cursor-pointer">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 31 31"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M15.5487 4.25C9.16775 4.25 3.97475 9.25175 3.9725 15.3988C3.971 17.3645 4.505 19.283 5.5175 20.9728L3.875 26.75L10.0122 25.1998C11.7194 26.0928 13.6176 26.5586 15.5442 26.5573H15.5487C21.9297 26.5573 27.1227 21.5548 27.125 15.4078C27.1265 12.4303 25.9235 9.6275 23.7372 7.52075C21.5517 5.41325 18.6455 4.25075 15.5487 4.25ZM15.5487 24.674H15.545C13.8185 24.674 12.125 24.227 10.6475 23.3825L10.295 23.1815L6.6545 24.101L7.6265 20.681L7.39775 20.3308C6.43693 18.8654 5.92545 17.151 5.92625 15.3988C5.9285 10.289 10.2455 6.13325 15.5525 6.13325C18.122 6.134 20.5377 7.09925 22.355 8.8505C24.1722 10.6018 25.172 12.9305 25.1705 15.407C25.1682 20.5168 20.852 24.674 15.548 24.674H15.5487ZM20.8265 17.7328C20.537 17.594 19.115 16.9198 18.8495 16.826C18.5847 16.7338 18.392 16.6858 18.1992 16.9648C18.0072 17.2438 17.4522 17.8715 17.2842 18.0568C17.1147 18.2428 16.946 18.2653 16.6565 18.1265C16.367 17.987 15.4347 17.693 14.3307 16.7435C13.4705 16.0055 12.89 15.0935 12.7212 14.8138C12.5525 14.5355 12.7032 14.3848 12.848 14.246C12.9777 14.1223 13.1375 13.9213 13.2815 13.7585C13.4255 13.5958 13.4735 13.4795 13.571 13.2935C13.667 13.1083 13.619 12.9448 13.5462 12.806C13.4735 12.6658 12.896 11.2948 12.6537 10.7375C12.4197 10.1945 12.1812 10.2673 12.0035 10.2583C11.8347 10.2508 11.6427 10.2485 11.4485 10.2485C11.2572 10.2485 10.943 10.3183 10.6775 10.5973C10.4127 10.8763 9.665 11.5498 9.665 12.9208C9.665 14.2925 10.7015 15.617 10.8462 15.803C10.991 15.9883 12.8862 18.803 15.788 20.0105C16.478 20.2963 17.0165 20.468 17.4372 20.597C18.1302 20.8093 18.761 20.7785 19.259 20.7073C19.814 20.627 20.9705 20.0338 21.2105 19.3835C21.452 18.7333 21.452 18.1753 21.38 18.059C21.3095 17.9428 21.116 17.873 20.8265 17.7328V17.7328Z"
                    fill="#25D366" />
                </svg>
              </div>
            </template>
            <template v-else>
              <div
                class="border-2-green rounded-circle overflow-hidden"
                style="height: 50px; width: 50px">
                <img
                  src="../../assets/img/icon/rider.png"
                  class="img-fit" />
              </div>
              <p class="mb-0 body-2-4 pl-3">
                <i>Searching for a driver...</i>
              </p>
            </template>
          </div>
        </div>
  
        <!-- TRACKING STATUS -->
        <div
          class="w-100 px-4 pb-4"
          style="margin-top: -75px;">
          <div
            class="w-100 mb-4 radius-1 p-3 border-form bg-white box-shadow-light-aff">
            <div
              class="d-flex align-items-center justify-content-between pb-3 mb-4 border-b-form">
              <p class="mb-0 body-2">Tracking ID</p>
              <p class="mb-0 body-2-4">{{ delivery.waybill_id	 }}</p>
            </div>
            <div class="w-100">
              <div
                class="w-100"
                v-for="(historyItem, historyIndex) in delivery.history">
                <div class="d-flex align-items-center">
                  <div class="pr-4 lh-1">
                    <svg
                      :class="{ 'opacity-03': historyIndex > 0 }"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.67969 21.5977H17.8945C20.3555 21.5977 21.5742 20.3789 21.5742 17.9648V3.65625C21.5742 1.24219 20.3555 0.0234375 17.8945 0.0234375H3.67969C1.23047 0.0234375 0 1.23047 0 3.65625V17.9648C0 20.3906 1.23047 21.5977 3.67969 21.5977Z"
                        :class="
                          historyIndex === 0
                            ? 'fill-success'
                            : 'fill-light'
                        " />
                      <path
                        v-if="historyIndex > 0"
                        d="M9.48047 16.5234C9.08203 16.5234 8.75391 16.3594 8.44922 15.9492L5.50781 12.3398C5.33203 12.1055 5.22656 11.8477 5.22656 11.5781C5.22656 11.0508 5.63672 10.6172 6.17578 10.6172C6.50391 10.6172 6.76172 10.7227 7.05469 11.1094L9.43359 14.1797L14.4375 6.14062C14.6602 5.78906 14.9648 5.60156 15.2812 5.60156C15.7852 5.60156 16.2656 5.95312 16.2656 6.50391C16.2656 6.76172 16.125 7.03125 15.9727 7.27734L10.4648 15.9492C10.2188 16.3359 9.87891 16.5234 9.48047 16.5234Z"
                        fill="white" />
                    </svg>
                  </div>
                  <div :class="{ 'opacity-06': historyIndex > 0 }">
                    <p class="mb-0 body-3-3-2">
                      {{ historyItem.description }}
                    </p>
                    <p class="mb-0 body-3-3-1">
                      {{ $formatDateTime(historyItem.updated_at) }}
                    </p>
                  </div>
                </div>
                <div
                  v-if="historyIndex + 1 < delivery.history.length"
                  class="py-3 border-l-form-2-dashed"
                  style="margin-left: 9px"></div>
              </div>
            </div>
          </div>
  
          <button
            v-if="transactionDetail.status !== 'COMPLETE'"
            @click="getDetailDelivery"
            class="g-btn g-btn-primary g-btn-lg w-100">
            Update Tracking
          </button>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { get } from '@/services/index.js';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  props: {
    module: {
      type: String,
      default: 'RESTAURANT',
    },
    transactionDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: true,
      error: '',
      delivery: {},
    };
  },
  computed: {
    ...mapGetters(['getMerchant']),
    showWaChat(){
      return this.$isNotEmptyV2(this.delivery.driver_phone);
    }
  },
  mounted() {
    this.getDetailDelivery();
  },
  methods: {
    async getDetailDelivery() {
      try {
        this.isLoading = true;
        this.error = '';

        const apiPath = `v2/tx-history/${this.transactionDetail.id}/delivery`;
        const apiResponse = await get('CORE_RESTO', apiPath, {
          merchant_id: this.getMerchant.id,
        });

        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);

        this.delivery = this.parsedDetailDelivery(data);
      } catch (error) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },
    parsedDetailDelivery(deliveryDetail) {
      let deliveryParsed = deliveryDetail;
      deliveryParsed.history = deliveryDetail.history
        .map((delivery) => {
          delivery.description = this.$parsingDeliveryStatus(
            delivery.status,
            delivery.currentNote
          );
          return delivery;
        })
        .reverse();
      return deliveryParsed;
    },
    maskingPlusChar(data) {
      let return_data = data.substring(0, 1);
      return return_data == '+' ? data.substring(1, data.length) : data;
    },
    goToWaChat() {
      if(!this.showWaChat) return;

      const url = `https://wa.me/${this.maskingPlusChar(
        this.delivery.driver_phone
      )}?text=`;

      this.$openLink(url, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/DeliveryTrack.vue